<template>
  <div :style="[customCss]" class="mb-6 w-full tile-bg-color rounded-lg shadow-lg">
    <div class="course-tile-list-v2 rounded-lg">
      <div class="text-xl font-bold pt-6 pl-6 body-heading-color inter-font-regular">
        <slot name="title"></slot>
      </div>
      <div class="p-6">
        <slot name="courses-list"> </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Courses',
  props: {
    listElements: {},
    getThemeSettings: {},
  },
  data() {
    return {};
  },

  computed: {
    customCss() {
      return {
        '--template-tile-bg-color': this.themeSettings.body_section
          .tile_bg_color,
        '--template-body-heading-color': this.themeSettings.body_section
          .body_heading_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss" scoped>
.tile-bg-color {
  background-color: var(--template-tile-bg-color);
}
.body-heading-color {
  color: var(--template-body-heading-color);
}
</style>

<style lang="scss">
.course-tile-list-v2 {
  .tile-img {
    max-width: 140px;
    width: 100%;
  }
}
.mobile-template{
    .course-tile-list-v2 {
      .flex{
        flex-direction: column;
        margin-right:0px;
        .tile-img{
          max-width: 100%;
          position: relative;
          height: 0;
          padding-bottom: 56.25%;
          overflow: hidden;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .text-wrapper-t2-tile{
          .title{
            margin-bottom: 1px;
          }
        }
      .description{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 227px;
        }
      .progress-bar-t2-tile{
        bottom: 14px;
        right: 0px;
        position: absolute;
      }
      }
    }
}

@media only screen and (max-width:767px){
    .course-tile-list-v2 {
      .flex{
        flex-direction: column;
        margin-right:0px;
        .tile-img{
          max-width: 100%;
          position: relative;
          height: 0;
          padding-bottom: 56.25%;
          overflow: hidden;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .text-wrapper-t2-tile{
          .title{
            margin-bottom: 1px;
          }
        }
        .description{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 227px;
        }
      
      .progress-bar-t2-tile{
        bottom: 14px;
        right: 0px;
        position: absolute;
      }
      }
    }
}

</style>